"use client";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { backgroundImage } from "../../components/image";

import AOS from "aos";
import "aos/dist/aos.css";

import Screen from "../../components/Screen";
import ProfileHeaderSection from "../../components/ProfileHeaderSection";
import HeaderDescription from "../../components/HeaderDescription";
import HeaderBox from "../../components/Box/HeaderBox";
import {
  BackButton,
  FowardButton,
} from "../../components/forms/DashboardButton";
import { Clickablebox } from "../../components/ClickableCircle";

const Organization = () => {
  const navigate = useNavigate();

  const handleprev = () => {
    navigate("/value");
  };
  const handleNext = () => {
    navigate("/directory");
  };
  const handleCto = () => {
    navigate("/cto");
  };
  const handlefinance = () => {
    navigate("/finance");
  };
  const handleGrowth = () => {
    navigate("/vp-growth");
  };

  const handleLbn = () => {
    navigate("/lbn");
  };
  const handleLBE = () => {
    navigate("/lbe");
  };
  const handleLBK = () => {
    navigate("/lbk");
  };
  const handleComms = () => {
    navigate("/communication");
  };

  const handleOpps = () => {
    navigate("/operations");
  };

  const handleBoat = () => {
    navigate("/boat");
  };

  const handlePeople = () => {
    navigate("/people");
  };

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div className="w-full">
      <Screen>
        <ProfileHeaderSection />
        <HeaderDescription
          maintext={"Dashboard"}
          subtext={"Our Team"}
          subsubtext={"Mission & Vison"}
        /> 
        <div>
          <p className={`text-lightDark text-3xl mt-2 mb-4 `}>
            Organization Chart
          </p>
        </div>
        <div className="">
          <HeaderBox text="A visual guide to LifeBank's structure and hierarchy" />
        </div>
        <div
          className="mt-4 mb-4 p-2 bg-no-repeat object-fit bg-cover h-[60%] rounded"
          data-aos="fade-up"
          data-aos-easing="linear"
          data-aos-duration="2000"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <div className="" style={{ marginTop: "10px", marginBottom: "10px" }}>
            <div className=" mb-4">
              <div className="h-20 w-40 rounded shadow-md bg-white flex items-center mx-auto justify-center text-lightDark hover:transition hover:duration-300 ease-in-out hover:bg-bloodRed hover:text-white">
                <p className="text-lightDark hover:text-white px-5 py-4 text-center flex items-center justify-center">
                Board of Directors
                </p>
              </div>
            </div>
            <div className=" hover:text-lightDark h-14 w-40 mt-2 mb-2 rounded-[8rem] shadow-md hover:bg-white flex item-center mx-auto justify-center text-white  bg-bloodRed">
              <p className={`  text-center flex  items-center justify-center `}>
              Group CEO
              </p>
            </div>
          </div>

          <div className="flex w-full justify-between">
            <Clickablebox
              title={"CTO"}
              onClick={handleCto}
              margin={16}
              className="p-2 mt-16 rounded-full border-red-300 border shadow-md bg-gray flex item-center mx-auto justify-center text-white hover:cursor-pointer hover:transition  hover:duration-300 ease-in-out hover:bg-bloodRed hover:text-white"
            />
            <Clickablebox
              title={"Executive Assistant"}
              // onClick={handleCto}
              margin={16}
              className="p-2 mt-16 rounded-full shadow-md border-bloodRed border  bg-white flex item-center mx-auto justify-center text-bloodRed hover:cursor-pointer hover:transition  hover:duration-300 ease-in-out hover:bg-bloodRed hover:text-white"
            />
          </div>

          <div className="mt-20 flex justify-start flex-col lg:flex-row gap-4">
            <div className="flex flex-col md:flex-row gap-4">
              {" "}
              {/* <Clickablebox
              title={"Director of people"}
              margin={24}
              onClick={handlePeople}
            /> */}
              {/*  <Clickablebox title={"C.T.O"} onClick={handleCto} margin={16} /> */}
              <Clickablebox
                title={"VP of Finance"}
                onClick={handlefinance}
                margin={16}
                className="p-2 mt-16 rounded-full border-red-300 border shadow-md bg-gray flex item-center mx-auto justify-center text-white hover:cursor-pointer hover:transition  hover:duration-300 ease-in-out hover:bg-bloodRed hover:text-white"
              />
              <Clickablebox
                title={"VP of Growth"}
                onClick={handleGrowth}
                margin={16}
                className="p-2 mt-16 rounded-full border-red-300 border shadow-md bg-gray flex item-center mx-auto justify-center text-white hover:cursor-pointer hover:transition  hover:duration-300 ease-in-out hover:bg-bloodRed hover:text-white"
              />
              <Clickablebox
                title={"VP of Sales"}
                onClick={handleLbn}
                margin={16}
                className="p-2 mt-16 rounded-full border-red-300 border shadow-md bg-gray flex item-center mx-auto justify-center text-white hover:cursor-pointer hover:transition  hover:duration-300 ease-in-out hover:bg-bloodRed hover:text-white"
              />
              <Clickablebox
                title={"CEO of LBK"}
                onClick={handleLBK}
                margin={16}
                className="p-2 mt-16 rounded-full border-red-300 border shadow-md bg-gray flex item-center mx-auto justify-center text-white hover:cursor-pointer hover:transition  hover:duration-300 ease-in-out hover:bg-bloodRed hover:text-white"
              />
              <Clickablebox
                title={"CEO of LBE"}
                margin={16}
                onClick={handleLBE}
                className="p-2 mt-16 rounded-full border-red-300 border shadow-md bg-gray flex item-center mx-auto justify-center text-white hover:cursor-pointer hover:transition  hover:duration-300 ease-in-out hover:bg-bloodRed hover:text-white"
              />
              <Clickablebox
                title={"VP of Operations"}
                margin={16}
                onClick={handleOpps}
                className="p-2 mt-16 rounded-full border-red-300 border shadow-md bg-gray flex item-center mx-auto justify-center text-white hover:cursor-pointer hover:transition  hover:duration-300 ease-in-out hover:bg-bloodRed hover:text-white"
              />
              {/* <Clickablebox title={"ED. Boat"} margin={16} onClick={handleBoat} />
            <Clickablebox
              title={"Director of communication"}
              margin={24}
              onClick={handleComms}
            /> */}
            </div>
          </div>

          <div className="flex justify-end w-full">
            <div className="flex flex-col md:flex-row gap-3">
              <Clickablebox
                title={"Director of Impact (BOAT)"}
                margin={24}
                onClick={handleBoat}
                className="p-2 mt-16 rounded-full shadow-md border-bloodRed border  bg-white flex item-center mx-auto justify-center text-bloodRed hover:cursor-pointer hover:transition  hover:duration-300 ease-in-out hover:bg-bloodRed hover:text-white"
              />
              <Clickablebox
                title={"Director of People"}
                margin={24}
                onClick={handlePeople}
                className="p-2 mt-16 rounded-full shadow-md border-bloodRed border  bg-white flex item-center mx-auto justify-center text-bloodRed hover:cursor-pointer hover:transition  hover:duration-300 ease-in-out hover:bg-bloodRed hover:text-white"
              />
              <Clickablebox
                title={"Director of Communications"}
                margin={24}
                onClick={handleComms}
                className="p-2 mt-16 rounded-full shadow-md border-bloodRed border  bg-white flex item-center mx-auto justify-center text-bloodRed hover:cursor-pointer hover:transition  hover:duration-300 ease-in-out hover:bg-bloodRed hover:text-white"
              />
            </div>
          </div>
        </div>

        <div className="my-2 flex bottom-2 gap-4 w-full justify-end">
          <BackButton
            text={"Previous"}
            onClick={handleprev}
            subText={"Value"}
          />
          <FowardButton
            text={"Next"}
            onClick={handleNext}
            subText={"Directory"}
          />
        </div>
      </Screen>
    </div>
  );
};

export default Organization;
